module.exports = __webpack_public_path__ + "f05a653ee656f5ce6461587b7147d783.svg";